import type { BlockCMS, Product } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'
interface ModuleBannerType {
  data: BlockCMS
}
const ModuleBanner = ({ data }: ModuleBannerType) => {
  const layout1 = (e: Product[]) => {
    return (
      <div className='w-full'>
        {e.map((item, index) => {
          return (
            <Link
              href={item?.path ? item?.path : '/'}
              className='block w-full'
              key={index}
            >
              {item?.image ? (
                <ImageOptimize
                  src={item?.image}
                  alt={getTranslate(item?.name) || data?.name || 'Banner khuyến mãi'}
                  width={1320}
                  height={466}
                  className='h-auto w-full'
                />
              ) : (
                ''
              )}
            </Link>
          )
        })}
      </div>
    )
  }
  const layout2 = (e: Product[]) => {
    return (
      <div className='px-2 grid w-full grid-cols-2 gap-2.5'>
        {e.map((item, index) => {
          return (
            <Link
              href={item?.path ? item?.path : '/'}
              className='block w-full'
              key={index}
            >
              {item?.image ? (
                <ImageOptimize
                  src={item?.image}
                  alt={getTranslate(item?.name) || data?.name || 'Banner khuyến mãi'}
                  width={900}
                  height={420}
                  className='h-auto w-full'
                />
              ) : (
                ''
              )}
            </Link>
          )
        })}
      </div>
    )
  }
  const layout3 = (e: Product[]) => {
    return (
      <div className='overflow-x-auto max-w-full hiddenScrollBar'>
        <div className='grid grid-cols-2 gap-2 px-2'>
          {e.map((item, index) => {
            return (
              <div className={`flex ${index == 0 ? 'row-span-2':''}`} key={index}>
                <Link
                  href={item?.path ? item?.path : '/'}
                  className='block w-full'
                >
                  {item?.image ? (
                    <ImageOptimize
                      src={item?.image}
                      alt={getTranslate(item?.name) || data?.name || 'Banner khuyến mãi'}
                      width={416}
                      height={151}
                      className='h-auto w-full'
                    />
                  ) : (
                    ''
                  )}
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <section
      id={data._id}
      className={`${data?.type} ${
        data?.hideBot ? '' : 'pb-3'
      } scroll-mt-[150px]`}
    >
      {data && data.cols === 1 ? layout1(data?.data) : ''}
      {data && data.cols === 2 ? layout2(data?.data) : ''}
      {data && data.cols === 3 ? layout3(data?.data) : ''}
    </section>
  )
}

export default ModuleBanner
